import { render } from "./TestResult.vue?vue&type=template&id=e0cec942"
import script from "./TestResult.vue?vue&type=script&lang=js"
export * from "./TestResult.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__